export interface ClientNotificationType {
  clientNotificationTypeID: number;
  typeName: string;
  defaultMessage: string;
}

export interface ClientNotification {
  notificationID: number;
  clientID: number;
  clientNotificationTypeID: number;
  createdAt: string;
  isRead: boolean;
  orderID?: number;
  subjectName?: string;
}

export interface EmailPreference {
  clientID: number;
  clientNotificationTypeID: number;
}

// for emails
export enum NotificationType {
  Reference = 1,
  Candidate = 2,
  Criminal = 3,
  Order = 4,
  NotifyCandidate = 5,
  Subscription = 6,
}
export interface NotifyRequest {
  orderId: number;
  type: NotificationType;
  detailId?: number;
  message?: string;
  signedResponseBase64?: string;
  baseUrl?: string;
  candidateEmail?: string;
}
